module.exports = __webpack_public_path__ + "img/btn-cover-disable.0e153c25.svg";